/**
 * Created by jonas on 2021-03-26.
 */
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";

export class LocalPresentation implements SimplePresentation {
    public start:(controller:SimplePresentationRunnerController) => void;
    public shouldRun:() => boolean;

    constructor(start:(controller:SimplePresentationRunnerController)=>void, shouldRun:()=>boolean) {
        this.start = start;
        this.shouldRun = shouldRun;
    }
}